<template>
    <div>
        <v-card>
            <v-toolbar card color="primary" class="white--text" >
                <v-toolbar-title><h4>Configuraciones del Sistema</h4></v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <v-switch
                                    label="Email Fin de cobertura habilitado"
                                    v-model="editedItem.email_fin_cobertura_habilitado"
                            ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="editedItem.email_fin_cobertura_dias"
                                    label="Días Antes"
                                    placeholder="Dias Antes"
                                    :error-messages="email_fin_cobertura_dias_errors"
                                    mask="##"
                                    required
                                    @input="$v.editedItem.email_fin_cobertura_dias.$touch()"
                                    @blur="$v.editedItem.email_fin_cobertura_dias.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    v-model="editedItem.email_fin_cobertura_texto"
                                    auto-grow
                                    box
                                    color="deep-purple"
                                    label="Texto Email fin de cobertura"
                                    rows="1"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-switch
                                    label="Email Poliza digital disponible habilitado"
                                    v-model="editedItem.email_poliza_subida_habilitado"
                            ></v-switch>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    v-model="editedItem.email_poliza_subida_texto"
                                    auto-grow
                                    box
                                    color="deep-purple"
                                    label="Texto Poliza digital disponible"
                                    rows="1"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-switch
                                    label="Notificación Revisión de póliza despues de N Días"
                                    v-model="editedItem.not_validez_despues_carga_habilitado"
                            ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    v-model="editedItem.not_validez_despues_carga_dias"
                                    label="Días Antes"
                                    placeholder="Dias Antes"
                                    :error-messages="not_validez_despues_carga_dias_errors"
                                    mask="##"
                                    required
                                    @input="$v.editedItem.not_validez_despues_carga_dias.$touch()"
                                    @blur="$v.editedItem.not_validez_despues_carga_dias.$touch()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    v-model="editedItem.not_validez_despues_carga_texto"
                                    auto-grow
                                    box
                                    color="deep-purple"
                                    label="Texto Notificación Revisión de póliza despues de N Días"
                                    rows="1"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="$v.$invalid" @click.native="save">Guardar</v-btn>
            </v-card-actions>
        </v-card>

        <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                    v-model="error">
            {{ errorMessage }}
            <v-btn secondary flat @click.native="error = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar color="success" v-if="success" :timeout="successTimeout" :bottom="true"
                    v-model="success">
            {{ successMessage }}
        </v-snackbar>
    </div>

</template>

<script>
  import { required, numeric } from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        crudDialog: false,
        editedItem: {
          id: '',
          email_fin_cobertura_dias: 0,
          email_fin_cobertura_texto: '',
          email_fin_cobertura_habilitado: false,
          email_poliza_subida_texto: '',
          email_poliza_subida_habilitado: false,
          not_validez_despues_carga_dias: 0,
          not_validez_despues_carga_texto: '',
          not_validez_despues_carga_habilitado: false
        },
        loading: false
      }
    },
    computed: {
      email_fin_cobertura_dias_errors () {
        let errors = []
        if (!this.$v.editedItem.email_fin_cobertura_dias.$dirty) return errors
        !this.$v.editedItem.email_fin_cobertura_dias.numeric && errors.push('Ingrese un Número')
        return errors
      },
      not_validez_despues_carga_dias_errors () {
        let errors = []
        if (!this.$v.editedItem.not_validez_despues_carga_dias.$dirty) return errors
        !this.$v.editedItem.not_validez_despues_carga_dias.numeric && errors.push('Ingrese un Número')
        return errors
      }
    },
    methods: {
      getConfig () {
        this.loading = true
        this.axios.get('/config/get').then(
          response => {
            this.editedItem = response.data
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar configuración'
            this.error = true
          }
        )
      },
      save () {
        this.editedItem.email_fin_cobertura_dias = parseInt(this.editedItem.email_fin_cobertura_dias)
        this.editedItem.not_validez_despues_carga_dias = parseInt(this.editedItem.not_validez_despues_carga_dias)
        this.axios.post('/config/update', this.editedItem).then(
          response => {
            this.successMessage = 'Configuración guardada exitosamente.'
            this.success = true
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar.'
            this.error = true
          }
        )
      }
    },
    validations: {
      editedItem: {
        not_validez_despues_carga_dias: {required, numeric},
        email_fin_cobertura_dias: {required, numeric}
      }
    },
    mounted () {
      this.getConfig()
    },
    name: 'AseguradoraList'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Admin/Configuracion.vue